<script setup lang="ts">
import type { CmsElementZebraCmsFaq } from "~/composables/useCustom";
import 'vue3-carousel/dist/carousel.css'

const props = defineProps<{
  content: CmsElementZebraCmsFaq;
}>();

const { headlineText, Faqs } = props.content?.config

</script>

<template>
  <section class="py-20 md:py-24 lg:py-130">
    <div class="container max-w-[1070px]">
      <h3 class="mb-3 md:mb-5 lg:mb-10">{{headlineText.value}}</h3>
      <div class="accordian-wrapper">
        <div class="accordian-item py-4" v-for="(faq, index) in Faqs.value">
          <div class="accordian-head" @click="faq.open = !faq.open">
            <h5 class="normal-case font-bold text-lg md:text-xl leading-6 after:content-['\f107'] after:inline-block flex items-center justify-between cursor-pointer">{{faq.faqTitle}}</h5>
          </div>
          <div class="accordian-details leading-6 pt-3 text-sm md:text-base" v-if="faq.open">
            <div v-html="faq.faqText"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
